tmElements = function () {
    return {
        cMultiStepRadio: function () {
            jQuery(document).on( "click", ".c-multi-step-radio .c-multi-step-radio-item:not(.c-multi-step-radio-item-disabled)", function () {
                jQuery(this).siblings(".c-multi-step-radio-item.c-multi-step-radio-item-selected").removeClass("c-multi-step-radio-item-selected");
                jQuery(this).addClass("c-multi-step-radio-item-selected");
            });
        },
        cTopFilter: function() {
            var $filterWrapper = $('.filter-container-top');

            if ( $filterWrapper.length === 0 ) {
                return;
            }

            function checkTopFilterSticky() {
                var rectTop = $filterWrapper[0].getBoundingClientRect().top;

                if (rectTop <= 0) {
                    $filterWrapper.addClass('c-filter-top-sticky');
                } else {
                    $filterWrapper.removeClass('c-filter-top-sticky');
                }
            }

            $(window).on('scroll', checkTopFilterSticky);

            checkTopFilterSticky();  

            $(".filter-popup").on("click", function() {
				var layout = $(".activity-sort .c-switch-radio-inner :checked").val();

                if ( layout === 'grid' || typeof layout === 'undefined' ) {
                    $(".sidebar.filter-container").addClass("open");
                    $(".activity-filter").addClass("open");

                    if ( $("body.desktop").length ){
                        $(".disable-all").show();                   
                    }

                    $("#filter-mobile").addClass("open");
                    $('html').addClass('filtersOpen');
                    setTimeout(function(){
                        $('body').css('overflow', 'hidden');
                    }, 500);                    
                } else {
                    $("html, body").animate({
                        scrollTop: ($(".sidebar").offset().top - 80 )
                    }, 500);                    
                }
            });

            $(".activity-filter .fsIconCollapse, .filter-container").on("click", function(e) {
                if ( $(e.target).hasClass("sidebar") || $(e.target).hasClass("fsIconCollapse") ){
                    $("body.desktop .sidebar.filter-container").removeClass("open");
                    $("body.desktop .activity-filter").removeClass("open");
                    $("body.desktop").css('overflow', 'auto');
                    $("body.desktop .disable-all").hide();                      
                }
            });
        },        
        cFilterPills: function() {
            try {
                jQuery('.c-dynamic-filters .slick-slider').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true,
                    draggable: false,
                    arrows: false,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: "unslick"
                        },
                    ]
                });
            } catch (e) {}
        },
        cAccordion: function(){
            if ( $('.c-accordion-item').length === 0 ) {
                return;
            }
            $('.c-accordion-item [role="button"]').on('click', function () {
                var item = $(this).closest('.c-accordion-item');
                // the item's own section: an accordion nested in it (the cookie popup's providers) has sections of its own
                var section = item.find('.c-accordion-section-wrapper').first();

                var isCollapsed = item.hasClass('c-accordion-item-collapsed');

                // Toggle class
                item.toggleClass('c-accordion-item-collapsed');

                // aria-expanded
                $(this).attr('aria-expanded', isCollapsed ? 'true' : 'false');

                // aria-hidden
                section.attr('aria-hidden', isCollapsed ? 'false' : 'true');

                // Smooth max-height animation using jQuery height measurement
                if (isCollapsed) {
                    var fullHeight = section.prop('scrollHeight');
                    section.css('max-height', fullHeight + 'px');
                    // an open accordion around this one grows by as much, so the opened item is not cut off
                    section.parents('.c-accordion-section-wrapper').each(function () {
                        $(this).css('max-height', (this.scrollHeight + fullHeight) + 'px');
                    });
                } else {
                    section.css('max-height', '0');
                }
            });
        },
        cPagination: function() {
            if ( $('.c-pagination').length === 0 ) {
                return;
            }

            $(document).on("click", ".c-pagination a", function(e){
                if ( ($(this).attr("href") || "").charAt(0) !== "#" ) {
                    return; // a real page link (components/pagination with page_url) just navigates
                }
                e.preventDefault();

                pageSelected = $(this).data("page");
                cPagination = $(this).parents(".c-pagination");
                if ( typeof pageSelected === "number" || typeof pageSelected === "string" ){
                    cPagination.find("a").removeClass("current");
                    $(this).addClass("current");
                }
            })
        },
        cToolTipPopup: function(){
            if ( $(".c-tooltip-wrapper--js").length ) {
                tmUtils.cToolTipJsFix();

                // only an open tooltip follows the page; a closed one is placed when it opens (below). The capture listener
                // fires for every scroll of every box, so it returns at once until a tooltip was opened (the flag, set
                // below); the computed-style check runs only then, and clears the flag again once no tooltip is open
                var toolTipMayBeOpen = false;
                var followOpenToolTip = function(){
                    if ( !toolTipMayBeOpen ) {
                        return;
                    }
                    var isOpen = $(".c-tooltip-wrapper--js .c-tooltip-content").filter(function () {
                        return getComputedStyle(this).display !== 'none';
                    }).length;

                    if ( isOpen ) {
                        tmUtils.cToolTipJsFix();
                    } else {
                        toolTipMayBeOpen = false;
                    }
                };
                $(window).on('resize', followOpenToolTip);
                // capture: a scroll inside a box (a modal body, the Accessibility panel) moves the trigger too (COOL 587)
                document.addEventListener('scroll', followOpenToolTip, { capture: true, passive: true });

                // mouseenter: hover on desktop; touchend: a tap on phones (custom.js toggleToolTip opens it after this)
                $(".c-tooltip-wrapper--js").on("mouseenter touchend", function () {
                    toolTipMayBeOpen = true;
                    tmUtils.cToolTipJsFix();
                });
             }   
        },
        cTourGrades: function() {
            if ( $(".c-tour-grade-list").length ) {
                $(".c-tour-grade-list .c-tour-grade-item").each(function(){
                    $(this).on("click", function(){
                        if ( $(this).hasClass("c-tour-grade-item-selected") ) {
                            return;
                        }
                        $(".c-tour-grade-list").find(".c-tour-grade-item-selected").removeClass("c-tour-grade-item-selected");
                        $(this).addClass("c-tour-grade-item-selected");
                        $(".c-tour-grade-list").find("input[type=radio]").prop("checked", false);
                        $(this).find("input[type=radio]").prop("checked", true);                        
                    });

                    $(this).find(".c-tour-grade-start-time button").on("click", function(){
                        if ( $(this).hasClass("c-btn-selected") ) {
                            return;
                        }
                        $(this).addClass("c-btn-selected");
                        $(this).parent().siblings().find("button").removeClass("c-btn-selected");
                    });
                });
            }
        },
        cCopyContent: function(){
            jQuery(document).on( "click", ".c-copy-content", function ( e ) {
                e.preventDefault();
                e.stopPropagation();

                const copyText = $(this).text().replace(/\s+/g, '');
                if ( copyText.length === 0 ) {
                    return;
                }
                navigator.clipboard.writeText(copyText);
                jQuery(document).trigger('tmToasterTrigger', {icon: 'fa-solid fa-copy', text: `Product ID ${copyText} copied`});

            });
        },

        switchCardLayout: function(){
            if ( $(".activity-sort").length === 0 ) {
                return;
            }

            $(".activity-sort input").on("change", function () {
                const activityLayout = $(this).val();

                // Layout change
                $(".content")
                    .removeClass("c-is-grid c-is-list")
                    .addClass("c-is-" + activityLayout);

                // URL update
                const url = new URL(window.location.href);
                url.searchParams.set("layout", activityLayout);

                // Address bar update (no page reload)
                history.replaceState({}, "", url.toString());
            });
        }
    }
}(window);

(function() {
    jQuery(document).ready(function () {
        tmElements.cMultiStepRadio();
        tmElements.cFilterPills();
        tmElements.cAccordion();
        tmElements.cPagination();
        tmElements.cToolTipPopup();     
        tmElements.cTopFilter();
        tmElements.cTourGrades();
        tmElements.switchCardLayout();
        tmElements.cCopyContent();
    });
})();